module.exports = __webpack_public_path__ + "static/media/205-Pflegemassnahmen_ID_27.92e62108.mp3";